<template>
    <client-page class="dark-theme">
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="교육 · 법률지원" src="/images/sub/sub-visual-education.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first page-section--last" data-aos="fade-up" data-aos-delay="100">
            <div v-if="application" class="board-container">
                <h5 class="tit tit--xxs mb-12px mb-md-20px">{{ application.subject }}</h5>
                <table class="board-view">
                    <tr>
                        <td colspan="2">
                            <!-- <span>작성자 : 관리자</span> &nbsp;&nbsp;&nbsp; -->
                            <v-row class="row--small">
                                <v-col cols="auto">
                                    <span>작성일 : {{ application.createdAt.toDate() }}</span>
                                </v-col>
                                <v-spacer/>
                                <v-col cols="auto">
                                    <v-layout align-center>
                                        <i class="icon icon-view mr-4px" />
                                        {{ application.viewCount }}
                                    </v-layout>
                                </v-col>
                            </v-row>
                        </td>
                    </tr>
                    <tr v-if="application.files">
                        <td colspan="2">
                            <v-layout align-center>
                                <span class="mr-10px">첨부파일</span>
                                <v-row class="row--xxs">
                                    <v-col v-for="file, index in application.files" :key="index" cols="auto">
                                        <v-chip x-small color="grey lighten-5" class="grey--text" @click="download(file, file.name.split('/').pop())">
                                            {{ file.name.split('/').pop() }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-layout>
                            <!-- <span> 첨부파일 : </span>
                            <span v-for="file, index in application.files" :key="index">
                                <v-icon>mdi-paperclip</v-icon>
                                <a @click="download(file, file.name.split('/').pop())" style="text-decoration:underline;">{{ file.name.split('/').pop() }}</a>
                            </span> -->
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="content_box">
                            <div v-html="application.content.replace(/\n/g,'<br>')"></div>
                        </td>
                    </tr>
                </table>

                <v-layout justify-end class="mt--md">
                    <v-btn outlined color="grey lighten-3" @click="$router.go(-1)"><span class="grey--text">리스트</span></v-btn>
                </v-layout>
            </div>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";
import download from "downloadjs";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/components/dumb/page-section.vue";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";
import IconDown from "@/components/client/icons/icon-down.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        IconArrowRounded,
        IconDown,
    },
    data() {
        return {
            application: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        download: (url, name) => api.resource.get(url).then((file) => download(file, name)),

        async init() {
            let { application } = await api.v1.legal.applications.get({ _id: this.$route.params._id });
            this.application = application;
        },
        shareKakao() {
            try {
                let key = ""; // 웹 API 키
                if (!key) throw new Error("카카오에서 JAVASCRIPT API 키를 발급받아 전달해주세요.(+ 카카오에 WEB 정보를 등록해주세요)");

                let shareUrl = location.href;

                if (!Kakao.isInitialized()) Kakao.init(key);
                Kakao.Share.sendDefault({
                    objectType: "feed",
                    content: {
                        title: this.application.subject,
                        // description: '#케익 #딸기 #삼평동 #카페 #분위기 #소개팅',
                        imageUrl: `https://${location.host}/${this.application.thumb.src}`,
                        link: {
                            // [내 애플리케이션] > [플랫폼] 에서 등록한 사이트 도메인과 일치해야 함
                            // mobileWebUrl: 'https://developers.kakao.com',
                            mobileWebUrl: shareUrl,
                            // webUrl: 'https://developers.kakao.com',
                            webUrl: shareUrl,
                        },
                    },
                });
            } catch (error) {
                alert(error.message);
            }
        },
        shareFacebook() {
            try {
                let shareUrl = location.href;

                location.href = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
            } catch (error) {
                alert(error.message);
            }
        },
        shareInstagram() {
            try {
                let client_id = ""; // 클라이언트 아이디
                if (!client_id) throw new Error("인스타그램 클라이언트 아이디를 발급받아 전달해주세요.");

                let shareUrl = location.href;

                location.href = `https://api.instagram.com/oauth/authorize/?client_id=${client_id}&redirect_uri=${shareUrl}&response_type=code`;
            } catch (error) {
                alert(error.message);
            }
        },
        copyClipboard() {
            try {
                if (!window?.navigator?.clipboard?.writeText) throw new Error("SSL 환경에서만 클립보드 복사 가능합니다");

                let shareUrl = location.href;

                window.navigator.clipboard.writeText(shareUrl);

                alert("복사 되었습니다");
            } catch (error) {
                alert(error.message);
            }
        },
    },
};
</script>
